import { createApp } from "vue";
import TDesign from "tdesign-vue-next";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import mitt from "mitt";
import Cookies from "js-cookie";
import i18n from "@/utils/i18n";
import vClickOutside from "@/utils/vClickOutside";
import DOMPurify from "dompurify";
// 按钮权限
import Permission from "./directive/permission";

// iconfont
import "./iconfont_svn/iconfont";
import "./iconfont_svn/iconfont.css";
// 样式
import "./style/common.css";
import "./style/VarCss.css";
import "./style/commonStyle.css";
import { doLoginLog, getTenantIdDomain } from "@/api/login";
import { getExternalInfo } from "@/api/base.js";
// 引入组件库的少量全局样式变量
import "tdesign-vue-next/es/style/index.css";

const app = createApp(App);
app.config.globalProperties.$eventBus = mitt();
app.use(store);
app.use(router);
app.use(TDesign);
app.directive("permission", Permission);
app.use(i18n);
app.use(i18n);
app.directive("clickOutside", {
  ...vClickOutside,
});
app.mount("#app");

// v-purify-html 安全处理 防止xss脚本攻击
app.directive("purify-html", {
  beforeMount: (el, binding) => {
    // el元素 dom操作可读可写 binding（只读）：通过自定义指令传递的参数都在这里 vnode（只读）：Vue编译生成的虚拟节点。
    // console.log(binding);
    let clean = DOMPurify.sanitize(binding.value);
    // px 转成rem布局
    // clean = clean.replace(/(\d+)px/g, function(s, t) {
    //     s = s.replace('px', '');
    //     var value = parseInt(s) * 0.0000000001; // 100px = 1rem
    //     return value + "rem"; //0.23rem
    // });
    el.innerHTML = clean;
  },
});

// 将学校id每次都存放在vuex中
if (!Cookies.get("schoolId")) {
  getTenantIdDomain(window.location.host).then((res) => {
    if (res.code == "1" && res.data) {
      Cookies.set("schoolId", res.data);
      store.commit("setSchoolId", res.data);
      // 特殊私有化部署 处理
      getExternalInfo().then((res) => {
        if (res.code == 1) {
          let externalIp = res.data ? res.data.externalIp : "";
          sessionStorage.setItem("enableExternal", externalIp);
        }
      });
    } else {
      console.log("域名获取到学校id报错了", res.msg);
    }
  });
} else {
  // 特殊私有化部署 处理
  getExternalInfo().then((res) => {
    if (res.code == 1) {
      let externalIp = res.data ? res.data.externalIp : "";
      sessionStorage.setItem("enableExternal", externalIp);
    }
  });
}
// 将学校id每次都存放在vuex中
if (Cookies.get("schoolId")) {
  const savedData = Cookies.get("schoolId");
  store.commit("setSchoolId", savedData);
}
var count = 0;
router.beforeEach((to, from, next) => {
  const getToken = Cookies.get("tokenValue");
  if (
    to.path === "/SSO" ||
    to.path === "/SSOBS" ||
    to.path === "/back/liveListDetail"
  ) {
    next(); // 继续路由导航
    return;
  }
  if (
    to.path === "/lengthen" ||
    to.path === "/login" ||
    to.path === "/qrlogin" ||
    to.path === "/register" ||
    to.path === "/qrRegister" ||
    to.path === "/activation" ||
    to.path === "/extendAuthorization" ||
    to.path === "/awaitPage"
  ) {
    // 如果用户已登录，且当前页面是登录页面，则跳转到主页
    if (getToken) {
      console.log("12312313", count, Cookies.get("logId"));
      if (count == 0 && Cookies.get("logId")) {
        doLoginLog(Cookies.get("logId"), 3);
        count++;
      }
      next();
    } else {
      next(); // 继续路由导航
    }
  } else {
    if (getToken) {
      if (count == 0 && Cookies.get("logId")) {
        doLoginLog(Cookies.get("logId"), 3);
        count++;
      }
    }
    // 如果用户未登录，并且不在登录页面，则跳转到登录页面
    if (!getToken) {
      const cookies = document.cookie.split("; ");
      cookies.forEach((cookie) => {
        const [name] = cookie.split("="); // 提取 Cookie 名称
        // 移除每个 Cookie
        Cookies.remove(name, { domain: window.g.localName });
      });
      // 巡课详情分享页面 记录当前访问平台是否是通过详情页 如果是则记录当前 访问路径 登陆时定位当前路径
      if(to.path === "/SCADA/ShareDetail"){
        sessionStorage.setItem("SCADA_ShareDetail", to.fullPath);// 存储路由完整地址
      }
      next({ path: "/login" });
    } else if (
      getToken &&
      !Cookies.get("schoolId") &&
      to.path !== "/wenxiang/userInfo"
    ) {
      // 有token但没有学校id，限制只能跳转到个人中心（绑定学校）
      next({ path: "/wenxiang/userInfo" });
    } else {
      next(); // 继续路由导航
    }
  }
});
